"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductModel = void 0;
const ModelCommon_1 = require("./ModelCommon");
const typeName = 'ProductModel';
class ProductModel extends ModelCommon_1.ModelCommon {
    //currently can't inhertit from Thing as constructor just expects ob. A consequence of 'can't user prototype.constructor.name in Webpack'
    constructor(ob) {
        super(ob.type || typeName, ob);
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
        };
    }
}
exports.ProductModel = ProductModel;
